import { render, staticRenderFns } from "./WrsViText.vue?vue&type=template&id=67767160&"
import script from "./WrsViText.vue?vue&type=script&lang=js&"
export * from "./WrsViText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports